import React from 'react';
import { Field, reduxForm } from 'redux-form';

import DatePicker from '../../shared/date-picker/main';
import moment from 'moment';

const Form = (props) => {
	return (
		<div>
			<form
				className="balances-report-form display-flex justify-content-flex-end margin-0-10 min-width-200"
			>
				<div className="ui-form__element">
					<Field
						name="date"
						intl={props.intl}
						onUpdate={props.datepickerChange}
						{...props.datepicker}
						component={DatePicker}
						onToggle={props.datepickerToggle}
						onApply={props.datepickerApply}
						maxDate={moment()}
					/>
				</div>
				<div className="download-accruals_buttons-container">
					<button
						className="ui-btn ui-btn-primary apply"
						type="button"
						onClick={() => props.getBalanceReport()}>
						{props.intl('Balances report')}
					</button>
				</div>
			</form>
		</div>
	);
};

export default reduxForm({
	form: 'balancesReportForm',
	enableReinitialize: false
})(Form);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/fin-reports/components/balances-report-form.js